export const formatPaddedAccountNumber = (accountNo?: number | string): string => {
  if (accountNo == null || accountNo === '') {
    return ''
  }

  const digits = String(accountNo).replace(/\D/g, '')

  if (!digits) {
    return ''
  }

  return digits.padStart(8, '0')
}
